// BatiAssistPresentationPage.jsx
// Page de présentation BatiAssist dans le contexte Espace Pro Abracadabati
// Affiche le contenu de la page LandingPage SANS le Header/Footer BatiAssist

import UnifiedHeader from '../../components/layout/UnifiedHeader';
import EspaceProNav from '../../components/layout/EspaceProNav';
import ImmersiveEspaceProWrapper from '../../components/layout/ImmersiveEspaceProWrapper';

// Import des sections de la page BatiAssist originale
import HeroSection from '../landing/HeroSection';
import ProblemSection from '../landing/ProblemSection';
import DiagnosticSection from '../landing/DiagnosticSection';
import SolutionSection from '../landing/SolutionSection';
import CRMSection from '../landing/CRMSection';
import ScreenshotsSection from '../landing/ScreenshotsSection';
import AgentsSection from '../landing/AgentsSection';
import SuperAssistantSection from '../landing/SuperAssistantSection';
import TransformationSection from '../landing/TransformationSection';
import PricingSection from '../landing/PricingSection';
import FounderSection from '../landing/FounderSection';
import FAQSection from '../landing/FAQSection';
import FinalCTASection from '../landing/FinalCTASection';
import BeforeAfterSection from '../landing/BeforeAfterSection';

export default function BatiAssistPresentationPage() {
  return (
    <ImmersiveEspaceProWrapper>
      <div className="min-h-screen bg-white" data-testid="batiassist-presentation-page">
        {/* Header Abracadabati */}
        <UnifiedHeader />
        
        
        {/* Sous-navigation Espace Pro */}
        <EspaceProNav />
        
        {/* Contenu BatiAssist SANS Header/Footer original */}
        <main>
          <HeroSection />
          <BeforeAfterSection />
          <ProblemSection />
          <SolutionSection />
          <CRMSection />
          <ScreenshotsSection />
          <AgentsSection />
          <SuperAssistantSection />
          <DiagnosticSection />
          <TransformationSection />
          <PricingSection />
          <FounderSection />
          <FAQSection />
          <FinalCTASection />
        </main>
      </div>
    </ImmersiveEspaceProWrapper>
  );
}
